import React from "react";

type StatusTagProps = {
  label: any;
  type?: any;
} & React.ComponentProps<"label">;

const defaultProps = {
  type: "success",
};

const StatusTag = (props: StatusTagProps) => {
  const { label, type, ...rest } = props;
  let classname = "";
  switch (type) {
		case 'success':
			classname = 'badge-light-success';
			break;
		case 'light':
			classname = 'badge-light';
			break;
		case 'primary':
			classname = 'badge-light-primary';
			break;
		case 'info':
			classname = 'badge-light-info';
			break;
		case 'warning':
			classname = 'badge-light-warning';
			break;
		default:
			classname = 'badge-light-danger';
			break;
  }
  //   const classname =
  //     type === "success"
  //       ? "badge-light-success"
  //       : type == "light"
  //       ? "badge-light"
  //       : "badge-light-danger";
  return (
    <span {...rest} className={`badge ${classname} ${props.className}`}>
      {label}
    </span>
  );
};

StatusTag.defaultProps = defaultProps;

export default StatusTag;
